import { put, select, takeEvery } from 'redux-saga/effects'

import { deleteOrganizationTeam, filterUsersByTeam, fetchUsersTrigger } from 'store/entities/organizations/actions'
import {
  getOrganizationUsersOrganizationId,
  getOrganizationUsersFilterByTeam,
  getOrganizationUsersTab,
} from 'store/entities/organizations/selectors'
// @ts-ignore
import { getIdentityOrganizationId, isAdmin } from 'store/entities/identity/selectors'

import { ALL } from 'app/constants/organizations'
import { modal } from 'store/entities/modal/actions'

export function* deleteTeamFromOrganizationSaga() {
  yield takeEvery(deleteOrganizationTeam.startAction.toString(), deleteTeamFromOrganization)
}

export function* deleteTeamFromOrganization() {
  let organizationId
  const admin = yield select(isAdmin)
  if (admin) {
    organizationId = yield select(getIdentityOrganizationId)
  } else {
    organizationId = yield select(getOrganizationUsersOrganizationId)
  }
  const teamName = yield select(getOrganizationUsersFilterByTeam)
  yield put(deleteOrganizationTeam({ organizationId, teamName }))
}

export function* deleteTeamFromOrganizationSuccess() {
  let organizationId
  const role = yield select(getOrganizationUsersTab)
  const admin = yield select(isAdmin)
  if (admin) {
    organizationId = yield select(getIdentityOrganizationId)
  } else {
    organizationId = yield select(getOrganizationUsersOrganizationId)
  }
  yield put(filterUsersByTeam(ALL))
  yield put(fetchUsersTrigger({ id: organizationId, page: 0, role, team: ALL, filterType: ALL }))
  yield put(modal.hide())
}

export function* deleteTeamFromOrganizationSuccessSaga() {
  yield takeEvery(deleteOrganizationTeam.success.toString(), deleteTeamFromOrganizationSuccess)
}
